export const updateRemoteLanguage = (lang) => {
    console.log('updateRemoteLanguage', window.dataApi);
    if (typeof window.dataApi?.changeLanguage !== 'function') {
        return;
    }

    return window.dataApi.changeLanguage({value: lang});
};